<template>
  <div class="Topbar">
    <a class="Topbar__logo" href="https://tesseract-v2.filing.clarivate.com/">
      <!-- eslint-disable vue/html-closing-bracket-spacing -->
      <svg
        height="64px"
        id="Artwork"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 167.24411 49.9249"
      >
        <path
          class="cls-1"
          d="M19.60791,32.0411a20.15594,20.15594,0,0,0,2.7974,5.1124,25.84406,25.84406,0,0,0,12.4819-7.215,20.33064,20.33064,0,0,0-3.0404-4.9742A20.30315,20.30315,0,0,1,19.60791,32.0411Z"
        />
        <path
          class="cls-2"
          d="M22.39061,12.7713a20.16824,20.16824,0,0,0-2.7861,5.1156,20.303,20.303,0,0,1,12.2423,7.0774,20.33064,20.33064,0,0,0,3.0404-4.9742A25.844,25.844,0,0,0,22.39061,12.7713Z"
        />
        <path
          d="M19.60791,32.0411a20.14235,20.14235,0,0,1-.5846-12.3341c.166-.6195.3615-1.226.5812-1.8201a20.34342,20.34342,0,0,0-5.82194-.1366,25.84179,25.84179,0,0,0-.00265,14.4276,20.34761,20.34761,0,0,0,5.828-.1368Z"
        />
        <path
          d="M51.46261,31.4913a5.25552,5.25552,0,0,0,5.3013-3.7108h4.2689a9.60311,9.60311,0,0,1-9.5702,7.2822,9.87755,9.87755,0,0,1-10.1838-10.1002,9.87757,9.87757,0,0,1,10.1838-10.1003,9.603,9.603,0,0,1,9.5702,7.2822h-4.2689a5.2554,5.2554,0,0,0-5.3013-3.7108c-3.6828,0-6.1381,2.7901-6.1381,6.5289S47.77981,31.4913,51.46261,31.4913Z"
        />
        <path d="M66.64171,34.7279h-3.5991V15.197h3.5991Z" />
        <path
          d="M76.63071,26.218c0-.9207-.7253-1.5067-2.1204-1.5067a8.685,8.685,0,0,0-3.8505,1.1998l-1.423-2.7343a10.93582,10.93582,0,0,1,5.4687-1.5625c2.9018,0,5.5525,1.3392,5.5525,4.7153v8.3983h-3.6273V33.5281a4.307,4.307,0,0,1-3.5714,1.5346,4.18873,4.18873,0,0,1-4.4641-4.0178c0-2.4274,1.7855-3.9341,4.6316-3.9341h2.5111c.6138,0,.8928-.279.8928-.7533Zm0,3.9341v-.9207a1.57666,1.57666,0,0,1-1.1161.2789h-1.3671c-1.1439,0-1.8135.5022-1.8135,1.3951,0,.8649.6974,1.5067,1.8135,1.5067A2.21073,2.21073,0,0,0,76.63071,30.1521Z"
        />
        <path
          d="M90.24711,25.5205h-1.5345c-1.8416,0-2.6786.8649-2.6786,3.097v6.1104h-3.6273V21.9491h3.5156v2.0368a3.36561,3.36561,0,0,1,3.3202-2.2042,4.10924,4.10924,0,0,1,1.0046.1116Z"
        />
        <path
          d="M97.362,34.7279h-3.6271V25.0182h-1.7856V21.9491H97.362ZM95.381,15.197a2.33976,2.33976,0,0,1,2.3437,2.3437,2.32979,2.32979,0,0,1-4.6595,0A2.33406,2.33406,0,0,1,95.381,15.197Z"
        />
        <path
          d="M105.50961,30.8217l2.9016-8.8726h3.8225l-4.5478,12.7788h-4.4921l-4.3526-12.7788h3.934Z"
        />
        <path
          d="M120.43721,26.218c0-.9207-.7255-1.5067-2.1206-1.5067a8.68538,8.68538,0,0,0-3.8505,1.1998l-1.4228-2.7343a10.93463,10.93463,0,0,1,5.4685-1.5625c2.9018,0,5.5525,1.3392,5.5525,4.7153v8.3983h-3.6271V33.5281a4.30756,4.30756,0,0,1-3.5714,1.5346,4.18879,4.18879,0,0,1-4.4643-4.0178c0-2.4274,1.7857-3.9341,4.6317-3.9341h2.511c.6138,0,.893-.279.893-.7533Zm0,3.9341v-.9207a1.57724,1.57724,0,0,1-1.1162.2789h-1.3671c-1.144,0-1.8136.5022-1.8136,1.3951,0,.8649.6975,1.5067,1.8136,1.5067A2.21085,2.21085,0,0,0,120.43721,30.1521Z"
        />
        <path
          d="M131.06811,17.0943v4.8548h2.7621v3.0691h-2.7621v5.7756c0,.8092.6416.9208,1.1996.9208.9207,0,1.674-.0837,1.674-.0837v3.097s-1.7577.1674-2.8181.1674c-1.8134,0-3.6828-.3069-3.6828-2.8738V25.0182h-2.0089V21.9491h2.0089V17.0943Z"
        />
        <path
          d="M148.31131,29.3987H138.797a3.03438,3.03438,0,0,0,5.4965,1.2556l3.7666.3906a6.84931,6.84931,0,0,1-13.0856-2.7064,6.47228,6.47228,0,0,1,6.6406-6.7242c3.5154,0,6.6962,2.2879,6.6962,7.645Zm-9.5982-2.4273h5.7199a2.77171,2.77171,0,0,0-2.8179-2.3438A2.85006,2.85006,0,0,0,138.71311,26.9714Z"
        />
        <path
          d="M150.27691,16.1177h-.9778v2.5708h-1.0173V16.1177h-.9778v-.9032h2.9729Z"
        />
        <path
          d="M152.26191,17.9443l-.4466-1.2407v1.9849h-.9777v-3.474h1.3417l.5069,1.4493.5417-1.4493h1.2623v3.474h-.9975V16.7036l-.4468,1.2407Z"
        />
      </svg>
    </a>

    <div class="Topbar__right">
      <!-- App Switch -->
      <div class="Menu" title="Service switch">
        <div class="Menu__header">
          <div class="Menu__infos">
            <div class="Menu__name">Current service</div>
            <div>{{ currentAppName }}</div>
          </div>
          <svg
            width="24"
            height="25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M17 11.8a1 1 0 0 0-1.4 1.4l3.7 3.8H1.4a1 1 0 0 0 0 2h17.9l-3.7 3.7a1 1 0 0 0 1.4 1.4l6.1-6.1-6-6.2zM6.8 13.4a1 1 0 0 0 .7-1.7L3.8 8h17.9a1 1 0 1 0 0-2H3.8l3.7-3.7A1 1 0 0 0 6.1.9L0 7l6.1 6.1a1 1 0 0 0 .7.4z"
              fill="#9BB1B7"
            />
          </svg>
        </div>
        <div class="Menu__content">
          <ul>
            <li class="Menu__label">
              Switch between services:
            </li>
            <li v-for="(app, key) in filteredApps" :key="key">
              <a class="Menu__link" :href="getAppURL(app)">
                {{ app.name }}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <!-- Portfolio Switch -->
      <div class="Menu Menu--account">
        <div class="Menu__header">
          <div class="Menu__infos">
            <div class="Menu__name">{{ $auth.user.fullName }}</div>
            <transition name="slide-fade" mode="out-in">
              <div
                v-if="searchPortfolioEnabled"
                :key="$auth.user.currentPortfolio.full_name"
                :title="$auth.user.currentPortfolio.full_name"
              >
                {{ $auth.user.currentPortfolio.full_name | truncate(40) }}
              </div>
              <div
                v-if="!searchPortfolioEnabled"
                :key="$auth.user.currentPortfolio.name"
              >
                {{ $auth.user.currentPortfolio.name }}
              </div>
            </transition>
          </div>
          <!-- eslint-disable-next-line vue/max-attributes-per-line -->
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="feather feather-chevron-down"
          >
            <polyline points="6 9 12 15 18 9"></polyline>
          </svg>
        </div>
        <div class="Menu__content">
          <ul>
            <li v-if="searchPortfolioEnabled">
              <PortfolioSwitcher
                :authHost="authHost"
                :switcher="switcher"
                :portfolios="localPortfolios"
                @addPortfolio="addPortfolio"
                @removePortfolio="removePortfolio"
              />
            </li>
            <li
              v-else
              v-for="p in $auth.user.portfolios.filter(
                (p) => p.uid !== $auth.user.currentPortfolio.uid
              )"
              :key="p.uid"
            >
              <a
                class="Menu__link"
                :class="
                  p.uid == $auth.user.currentPortfolio.uid
                    ? 'Menu__link--active'
                    : ''
                "
                @click="$auth.setCurrentPortfolio(p)"
                >{{ p.name }}</a
              >
            </li>
            <hr />
            <!--<li>
              Backend link
            </li>-->
            <li>
              <a
                class="Menu__link"
                href="mailto:support.delegate@cpaglobal.com"
              >
                <!-- eslint-disable-next-line vue/max-attributes-per-line -->
                <span class="Menu__dropdownIcon"
                  ><svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <circle cx="12" cy="12" r="10"></circle>
                    <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
                    <line x1="12" y1="17" x2="12" y2="17"></line></svg
                ></span>
                Contact us
              </a>
            </li>
            <li>
              <a class="Menu__link" href="https://www.delegateip.com/">
                <span class="Menu__dropdownIcon"
                  ><svg
                    width="22"
                    height="22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11 21c5.523 0 10-4.477 10-10S16.523 1 11 1 1 5.477 1 11s4.477 10 10 10zM1 11h20"
                      stroke="currentcolor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M11 1a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"
                      stroke="currentcolor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    /></svg
                ></span>
                Website
              </a>
            </li>
            <li>
              <a
                class="Menu__link"
                href="https://auth.filing.clarivate.com/profile/edit"
              >
                <span class="Menu__dropdownIcon"
                  ><svg
                    width="24"
                    height="25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 15.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M19.4 15.5a1.65 1.65 0 0 0 .33 1.82l.06.06a1.998 1.998 0 0 1 0 2.83 1.998 1.998 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51v.17a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.9a1.65 1.65 0 0 0-1.82.33l-.06.06a1.998 1.998 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.6 9.5a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3.5a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 3.417 1.415 2 2 0 0 1-.587 1.415l-.06.06a1.65 1.65 0 0 0-.33 1.82v.08a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-miterlimit="10"
                    /></svg
                ></span>
                Settings
              </a>
            </li>
            <li>
              <a
                class="Menu__link"
                href="https://auth.filing.clarivate.com/users/sign_out"
                @click.prevent="$auth.logout()"
              >
                <span class="Menu__dropdownIcon"
                  ><svg
                    width="20"
                    height="23"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16.365 6.14a9 9 0 1 1-12.73 0M10.005 1.5v10"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    /></svg
                ></span>
                Log out
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import truncate from "@synbioz/truncate";
import getAPIClient from "@delegate/auth-api-client";
import appListMixin from "../appListMixin";
import PortfolioSwitcher from "./PortfolioSwitcher";

let api;

export default {
  mixins: [appListMixin],
  props: {
    authHost: {
      type: String,
      required: true,
    },
    switcher: {
      type: Object,
      default: () => ({
        minLengthSearch: 3,
        maxPortfolio: 5,
        pageSize: 50,
        excludedRoles: ["customer"],
      }),
    },
  },
  data() {
    return {
      localPortfolios: [],
    };
  },
  computed: {
    searchPortfolioEnabled() {
      return !this.$auth.user.roles.some((role) =>
        this.switcher.excludedRoles.includes(role)
      );
    },
    portfolioSwitcherProps() {
      const props = { ...this.$props };

      delete props.apps;

      return {
        ...props,
      };
    },
  },
  methods: {
    addPortfolio(portfolio) {
      if (!portfolio) {
        return;
      }

      this.localPortfolios = [
        portfolio,
        ...this.localPortfolios.slice(0, this.switcher.maxPortfolio - 1),
      ];

      localStorage.setItem(
        "localPortfolios",
        JSON.stringify(this.localPortfolios)
      );
      this.$auth.setCurrentPortfolio(portfolio);
    },
    removePortfolio(portfolio) {
      this.localPortfolios = this.localPortfolios.filter(
        (p) => portfolio.uid !== p.uid
      );
      localStorage.setItem(
        "localPortfolios",
        JSON.stringify(this.localPortfolios)
      );
    },
    async setInitialPortfolio() {
      const currentPortfolioUID = (
        window.location.hash.match(/\?portfolio=(.+)/) || [
          this.$auth.user.currentPortfolio.uid,
        ]
      ).pop();

      if (!currentPortfolioUID) {
        this.setDefaultPortfolio();

        return;
      }

      if (this.localPortfolios.some((p) => p.uid === currentPortfolioUID)) {
        this.$auth.setCurrentPortfolio(
          this.localPortfolios.find((p) => p.uid === currentPortfolioUID)
        );

        return;
      }

      try {
        const response = await api.getPortfolio(currentPortfolioUID);

        this.addPortfolio(response.portfolio);
      } catch (e) {
        console.error(e);
        this.setDefaultPortfolio();
      }
    },
    setDefaultPortfolio() {
      if (this.localPortfolios.length > 0) {
        this.$auth.setCurrentPortfolio(this.localPortfolios[0]);
      }
    },
  },
  created() {
    api = getAPIClient(this.authHost, this.$auth.fetch);

    if (this.searchPortfolioEnabled) {
      const storedPortfolios = localStorage.getItem("localPortfolios");

      if (storedPortfolios) {
        this.localPortfolios = JSON.parse(storedPortfolios);
      }

      this.setInitialPortfolio();
    }
  },
  filters: { truncate },
  components: { PortfolioSwitcher },
};
</script>
<style src="../assets/stylesheets/_topbar.scss" lang="scss" scoped></style>
<style>
.slide-fade-enter-active {
  transition: all 0.4s ease;
}
.slide-fade-leave-active {
  transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(30px);
  opacity: 0;
}
.cls-1 {
  fill: #16ab03;
}
.cls-2 {
  fill: #5e33bf;
}
</style>
